<template>
  <section class="service section">
    <div class="container">
      <div class="section-header">
        <span class="section-label">服务保障</span>
        <h2 class="section-title">政务项目需要的不只是软件<br>还有长期稳定的交付能力</h2>
      </div>

      <div class="service__grid">
        <div
          v-for="item in services"
          :key="item.title"
          class="service__card"
        >
          <div class="service__icon">{{ item.icon }}</div>
          <h3 class="service__title">{{ item.title }}</h3>
          <p class="service__desc">{{ item.desc }}</p>
        </div>
      </div>

      <div class="service__tags">
        <span v-for="tag in serviceTags" :key="tag" class="service__tag">{{ tag }}</span>
      </div>
    </div>
  </section>
</template>

<script>
import { services, serviceTags } from '../data/site'

export default {
  name: 'ServiceSection',
  data() {
    return { services, serviceTags }
  }
}
</script>

<style scoped>
.service {
  background: #fff;
}

.service__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 40px;
}

.service__card {
  text-align: center;
  padding: 32px 20px;
  border-radius: 12px;
  background: #f7f9fc;
  border: 1px solid #eef1f6;
}

.service__icon {
  font-size: 32px;
  margin-bottom: 16px;
}

.service__title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 10px;
}

.service__desc {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
}

.service__tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

.service__tag {
  padding: 8px 20px;
  background: #f0f5ff;
  color: #0052d9;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #d6e4ff;
}

@media (max-width: 960px) {
  .service__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .service__grid {
    grid-template-columns: 1fr;
  }
}
</style>
